import { createFallback, type Fallback } from "./fallback.js";
import { DEFAULT_TOOLBOX_MODEL } from "./constants.js";
import { createGuard, type Guard } from "./guard.js";
import { createRouter, type Router } from "./router.js";
import { createTracker, type Tracker, type TrackerOptions } from "./tracker.js";

export type AiToolboxOptions = {
  /** Profile/choice or model id when no router rule matches. @default {@link DEFAULT_TOOLBOX_MODEL} */
  defaultModel?: string;
  apiKey?: string;
  storage?: TrackerOptions["storage"];
  sqlitePath?: string;
};

export class AIToolbox {
  readonly tracker: Tracker;
  readonly router: Router;
  readonly guard: Guard;
  readonly fallback: Fallback;

  constructor(options: AiToolboxOptions = {}) {
    this.tracker = createTracker({
      storage: options.storage,
      sqlitePath: options.sqlitePath,
    });
    this.router = createRouter(options.defaultModel ?? DEFAULT_TOOLBOX_MODEL);
    this.guard = createGuard();
    this.fallback = createFallback();
  }
}
